var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChargedMessageDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 97,
    viewBox: "0 0 118 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4267 18.5C7.88009 26.7228 3.70038 37.482 3.71685 48.6429C3.71685 73.2991 23.7035 93.2857 48.3597 93.2857C59.2371 93.3021 69.7433 89.3315 77.891 82.125M32.7347 6.8125C37.6008 4.99554 42.8642 4 48.3597 4C67.2183 4 83.3451 15.6924 89.8865 32.2236",
    stroke: "#F8F8F8",
    strokeWidth: 6.69643,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9654 62.0357C37.8404 65.8749 43.1931 68.0624 48.3583 68.2455M48.3583 68.2455C53.3315 68.4241 58.135 66.7455 60.3984 62.8973M48.3583 68.2455V77.6607M37.1975 37.4821C37.1975 42.7544 41.0011 44.9151 45.6172 46.4107M61.7511 33.0178C58.6931 29.9598 53.3091 27.8348 48.3583 27.7008V19.6249M8.17969 8.46423L88.5368 88.8214",
    stroke: "#F8F8F8",
    strokeWidth: 6.69643,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5281 50.2184H105.401M89.5281 58.6218H101.433M109.369 39.7142C110.948 39.7142 112.462 40.3782 113.578 41.5602C114.695 42.7422 115.322 44.3452 115.322 46.0168V62.8235C115.322 64.495 114.695 66.0981 113.578 67.28C112.462 68.462 110.948 69.126 109.369 69.126H99.4487L89.5281 75.4285V69.126H85.5598C83.9811 69.126 82.4671 68.462 81.3508 67.28C80.2345 66.0981 79.6074 64.495 79.6074 62.8235V46.0168C79.6074 44.3452 80.2345 42.7422 81.3508 41.5602C82.4671 40.3782 83.9811 39.7142 85.5598 39.7142H109.369Z",
    stroke: "white",
    strokeWidth: 3.96825,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargedMessageDisable);
export default __webpack_public_path__ + "static/media/charged-message-disable.e756fb4ccd6ef5d0bae102c79b4ad0e6.svg";
export { ForwardRef as ReactComponent };